import { AvailableActions } from "api/generated/model";

import { useUserStatusQuery } from "../queries/useUserStatusQuery";

export const useAvailableActions = (): AvailableActions => {
    const { data: userStatus } = useUserStatusQuery();
    return userStatus.actions;
};
